<template>
  <div class="empty-holder">
    <slot>
      <div class="empty-center">
        <img
          alt="暂无数据"
          class="empty-img"
          src="@/assets/img/search-empty-holder.png"
        />
        <div class="empty-btn">
          <slot name="empty-btn">
            <span>{{ tips }}</span>
          </slot>
        </div>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  name: "empty-holder",
  props: {
    tips: {
      type: String,
      default: "这里还是空的哦 ~",
    },
  },
  data: function () {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.empty-holder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .empty-center {
    padding: 40px;
    text-align: center;
  }
  .empty-btn {
    text-align: center;
    color: var(--color-info-light);
    font-size: 14px;
  }
}
</style>
